import * as mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    chatUnread: 0,
    showVikiMsg: {
      show: false,
      id: null,
      msg: "",
      type: "",
      op: {
        type: "",
        clientId: null,
        userId: null,
        clients: [],
        taskId: null
      },
      op_code: "",
      cond: false,
      sub_cond: "",
      updatedAt: null,
      options: null
    },
    tooltipObject: {
      group: null,
      coordinates: null,
      tooltipSelector: null
    }
  },

  mutations,

  getters: {
    showVikiMsg: state => {
      return state.showVikiMsg;
    },
    showTooltip: state => {
      return state.tooltipObject;
    },
    chatUnread: state => state.chatUnread
  }
};
